export const ExploreData = {
  topProjects: [
    {
      id: "1",
      projectPlace: "Belagavi 2.0",
      profileName: "Sheetal Ugare",
      profileImage:
        "https://cdn.pixabay.com/photo/2015/04/23/22/00/tree-736885_1280.jpg",
      isFollowing: false,
      projectStatus: "Completed",
    },
    {
      id: "2",
      projectPlace: "Mandya 2.0",
      profileName: "Punya B K",
      profileImage:
        "https://images.unsplash.com/photo-1512341689857-198e7e2f3ca8?auto=format&fit=crop&w=400&h=250&q=60",
      isFollowing: false,
      projectStatus: "Upcoming",
    },
    {
      id: "3",
      projectPlace: "Bangalore 2.0",
      profileName: "Michael J",
      profileImage:
        "https://images.unsplash.com/photo-1537996194471-e657df975ab4?auto=format&fit=crop&w=400&h=250",
      isFollowing: false,
      projectStatus: "Ongoing",
    },
    {
      id: "4",
      projectPlace: "Bellarry 2.0",
      profileName: "Santosh VK",
      profileImage:
        "https://images.unsplash.com/photo-1538032746644-0212e812a9e7?auto=format&fit=crop&w=400&h=250&q=60",
      isFollowing: false,
      projectStatus: "Ongoing",
    },
    {
      id: "5",
      projectPlace: "Dharwad 2.0",
      profileName: "Karthik M",
      profileImage:
        "https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxzZWFyY2h8M3x8cHJvZmlsZXxlbnwwfHwwfHw%3D&auto=format&fit=crop&w=500&q=60",
      isFollowing: false,
      projectStatus: "Upcoming",
    },
    {
      id: "2",
      projectPlace: "Mandya 2.0",
      profileName: "Punya B K",
      profileImage:
        "https://images.unsplash.com/photo-1512341689857-198e7e2f3ca8?auto=format&fit=crop&w=400&h=250&q=60",
      isFollowing: false,
      projectStatus: "Upcoming",
    },
    {
      id: "3",
      projectPlace: "Bangalore 2.0",
      profileName: "Michael J",
      profileImage:
        "https://images.unsplash.com/photo-1537996194471-e657df975ab4?auto=format&fit=crop&w=400&h=250",
      isFollowing: false,
      projectStatus: "Ongoing",
    },
    {
      id: "4",
      projectPlace: "Bellarry 2.0",
      profileName: "Santosh VK",
      profileImage:
        "https://images.unsplash.com/photo-1538032746644-0212e812a9e7?auto=format&fit=crop&w=400&h=250&q=60",
      isFollowing: false,
      projectStatus: "Ongoing",
    },
    {
      id: "5",
      projectPlace: "Dharwad 2.0",
      profileName: "Karthik M",
      profileImage:
        "https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxzZWFyY2h8M3x8cHJvZmlsZXxlbnwwfHwwfHw%3D&auto=format&fit=crop&w=500&q=60",
      isFollowing: false,
      projectStatus: "Upcoming",
    },
  ],
  topEvents: [
    {
      id: "1",
      eventType: "free",
      isRegistered: false,
      eventPlace: "Dharwad city 2.0",
      eventDate: "09 Jun",
      eventImage: "https://picsum.photos/2400",
    },
    {
      id: "2",
      eventType: "Paid",
      isRegistered: false,
      eventPlace: "Hubballi city 2.0",
      eventDate: "09 Jun",
      eventImage:
        "https://images.unsplash.com/photo-1538032746644-0212e812a9e7?auto=format&fit=crop&w=400&h=250&q=60",
    },
    {
      id: "3",
      eventType: "Paid",
      isRegistered: false,
      eventPlace: "Bangalore city 2.0",
      eventDate: "09 Jun",
      eventImage: "https://picsum.photos/2000",
    },
    {
      id: "4",
      eventType: "free",
      isRegistered: true,
      eventPlace: "Maddur city 2.0",
      eventDate: "09 Jun",
      eventImage: "https://picsum.photos/2100",
    },
    {
      id: "5",
      eventType: "finished",
      isRegistered: false,
      eventPlace: "Belagavi city 2.0",
      eventDate: "09 Jun",
      eventImage:
        "https://images.unsplash.com/photo-1512341689857-198e7e2f3ca8?auto=format&fit=crop&w=400&h=250&q=60",
    },
    {
      id: "6",
      eventType: "free",
      isRegistered: true,
      eventPlace: "Maddur city 2.0",
      eventDate: "09 Jun",
      eventImage: "https://picsum.photos/2700",
    },
  ],
  feauturedArtist: [
    {
      id: "1",
      artistName: "sheetal Ugare Sheetal C Ugare Sheetal C Ugare",
      artistType: [
        { id: "1", type: "guitarist" },
        { id: "2", type: "pionist" },
        { id: "3", type: "Music" },
        { id: "4", type: "Sitar" },
      ],
      isFollowing: false,
      artistProfile:
        "https://media.istockphoto.com/id/1432594499/photo/thoughtful-senior-man-on-wheelchair-at-home.jpg?s=612x612&w=0&k=20&c=UafRg7zvoq28702-rv9-Ot77QUqZCr0xyIJOc5f756g=",
      coverImage:
        "https://images.unsplash.com/photo-1528459801416-a9e53bbf4e17?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=712&q=80",
    },
    {
      id: "2",
      artistName: "Punya B K",
      isFollowing: false,
      artistType: [
        { id: "1", type: "flutist" },
        { id: "2", type: "pionist" },
      ],
      artistProfile:
        "https://media.istockphoto.com/id/1436336745/photo/close-up-image-of-indian-man-sitting-in-velvet-cinema-seat-to-watch-film-tub-of-popcorn-rows.jpg?s=612x612&w=0&k=20&c=0R3v1ic-y2HeWwc2NloyB11jQ7ZP94rjZT88Olf1NOc=",
      coverImage:
        "https://images.unsplash.com/photo-1623627484632-f041d1fb366d?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1074&q=80",
    },
    {
      id: "3",
      artistName: "Michael Johnson",
      isFollowing: false,
      artistType: [
        { id: "1", type: "guitarist" },
        { id: "2", type: "pionist" },
      ],
      artistProfile:
        "https://media.istockphoto.com/id/1277345160/photo/child-face-close-up.jpg?s=612x612&w=0&k=20&c=uu0ftbTmBPheP78o4w_ULRx7dGGnshndGUJoT86XgR0=",
      coverImage:
        "https://images.unsplash.com/photo-1614850715649-1d0106293bd1?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2070&q=80",
    },
    {
      id: "4",
      artistName: "Akash Bogar",
      isFollowing: false,
      artistType: [
        { id: "1", type: "guitarist" },
        { id: "2", type: "pionist" },
      ],
      artistProfile:
        "https://media.istockphoto.com/id/1411772543/photo/side-profile-of-african-woman-with-afro-isolated-against-a-white-background-in-a-studio.jpg?b=1&s=170667a&w=0&k=20&c=AXoZk6bD-xbU4AQ66k4AKpWBRuDgHufmP4A1_Gn_5zg=",
      coverImage:
        "https://images.unsplash.com/photo-1523867574998-1a336b6ded04?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80",
    },
    {
      id: "5",
      artistName: "Santosh VK",
      isFollowing: false,
      artistType: [
        { id: "1", type: "guitarist" },
        { id: "2", type: "pionist" },
      ],
      artistProfile:
        "https://media.istockphoto.com/id/1381221247/photo/beautiful-afro-girl-with-curly-hairstyle.jpg?b=1&s=170667a&w=0&k=20&c=0x91osZOkL8EfhTEEGNa2EeCGN2gdMTNULOsUFW_0i4=",
      coverImage:
        "https://images.unsplash.com/photo-1484589065579-248aad0d8b13?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=759&q=80",
    },
    {
      id: "6",
      artistName: "Karthik M",
      isFollowing: false,
      artistType: [
        { id: "1", type: "guitarist" },
        { id: "2", type: "pionist" },
      ],
      artistProfile:
        "https://media.istockphoto.com/id/1351147752/photo/studio-portrait-of-attractive-20-year-old-bearded-man.jpg?b=1&s=170667a&w=0&k=20&c=N-Uwgbn8qhGypoXFB6keEEC3mW0qhNynAqBqd8oNJw0=",
      coverImage:
        "https://images.unsplash.com/photo-1510153704066-32b97a2d3c34?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=687&q=80",
    },
    {
      id: "7",
      artistName: "Chetan P",
      isFollowing: false,
      artistType: [
        { id: "1", type: "guitarist" },
        { id: "2", type: "pionist" },
      ],
      artistProfile:
        "https://media.istockphoto.com/id/1406197730/photo/portrait-of-a-young-handsome-indian-man.jpg?b=1&s=170667a&w=0&k=20&c=KtmKHyOE6MJV0w2DiGX8P4399KHNbZ3p8lCjTEabGcY=",
      coverImage:
        "https://images.unsplash.com/photo-1487088678257-3a541e6e3922?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1074&q=80",
    },
    {
      id: "8",
      artistName: "Tharvin Ram",
      isFollowing: false,
      artistType: [
        { id: "1", type: "guitarist" },
        { id: "2", type: "pionist" },
      ],
      artistProfile:
        "https://media.istockphoto.com/id/1365997131/photo/portrait-of-mid-20s-african-american-man-outdoors-at-dusk.jpg?b=1&s=170667a&w=0&k=20&c=_XMq-GZm_VV-N_kS8KCHp1nNjhdKkaLz0JgRdl3OlAk=",
      coverImage:
        "https://images.unsplash.com/photo-1487088678257-3a541e6e3922?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1074&q=80",
    },
    {
      id: "9",
      artistName: "Ravindra Manvi",
      isFollowing: false,
      artistType: [
        { id: "1", type: "guitarist" },
        { id: "2", type: "pionist" },
      ],
      artistProfile:
        "https://media.istockphoto.com/id/1338134336/photo/headshot-portrait-african-30s-man-smile-look-at-camera.jpg?b=1&s=170667a&w=0&k=20&c=j-oMdWCMLx5rIx-_W33o3q3aW9CiAWEvv9XrJQ3fTMU=",
      coverImage:
        "https://images.unsplash.com/photo-1494253109108-2e30c049369b?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80",
    },
    {
      id: "10",
      artistName: "Sanjeev Savala",
      isFollowing: false,
      artistType: [
        { id: "1", type: "guitarist" },
        { id: "2", type: "pionist" },
      ],
      artistProfile:
        "https://images.unsplash.com/photo-1529665253569-6d01c0eaf7b6?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxzZWFyY2h8NHx8cHJvZmlsZXxlbnwwfHwwfHw%3D&auto=format&fit=crop&w=500&q=60",
      coverImage:
        "https://images.unsplash.com/photo-1494253109108-2e30c049369b?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80",
    },
    {
      id: "11",
      artistName: "Akash J",
      isFollowing: false,
      artistType: [{ id: "1", type: "guitarist" }],
      artistProfile:
        "https://media.istockphoto.com/id/1365997131/photo/portrait-of-mid-20s-african-american-man-outdoors-at-dusk.jpg?b=1&s=170667a&w=0&k=20&c=_XMq-GZm_VV-N_kS8KCHp1nNjhdKkaLz0JgRdl3OlAk=",
      coverImage:
        "https://images.unsplash.com/photo-1509978778156-518eea30166b?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=715&q=80",
    },
    {
      id: "12",
      artistName: "Sudarshan S",
      isFollowing: false,
      artistType: [
        { id: "1", type: "guitarist" },
        { id: "2", type: "pionist" },
      ],
      artistProfile:
        "https://media.istockphoto.com/id/1338134336/photo/headshot-portrait-african-30s-man-smile-look-at-camera.jpg?b=1&s=170667a&w=0&k=20&c=j-oMdWCMLx5rIx-_W33o3q3aW9CiAWEvv9XrJQ3fTMU=",
      coverImage:
        "https://images.unsplash.com/photo-1573676564795-be0f1e7396dc?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80",
    },
    {
      id: "13",
      artistName: "Chandrakant T",
      isFollowing: false,
      artistType: [{ id: "1", type: "guitarist" }],
      artistProfile:
        "https://images.unsplash.com/photo-1529665253569-6d01c0eaf7b6?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxzZWFyY2h8NHx8cHJvZmlsZXxlbnwwfHwwfHw%3D&auto=format&fit=crop&w=500&q=60",
      coverImage:
        "https://images.unsplash.com/photo-1560697529-7236591c0066?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80",
    },
    {
      id: "14",
      artistName: "Manoj Belavi",
      isFollowing: false,
      artistType: [
        { id: "1", type: "guitarist" },
        { id: "2", type: "pionist" },
      ],
      artistProfile:
        "https://media.istockphoto.com/id/1365997131/photo/portrait-of-mid-20s-african-american-man-outdoors-at-dusk.jpg?b=1&s=170667a&w=0&k=20&c=_XMq-GZm_VV-N_kS8KCHp1nNjhdKkaLz0JgRdl3OlAk=",
      coverImage:
        "https://images.unsplash.com/photo-1494894194458-0174142560c0?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80",
    },
    {
      id: "15",
      artistName: "Arpita Patil",
      isFollowing: false,
      artistType: [
        { id: "1", type: "guitarist" },
        { id: "2", type: "photography" },
      ],
      artistProfile:
        "https://media.istockphoto.com/id/1338134336/photo/headshot-portrait-african-30s-man-smile-look-at-camera.jpg?b=1&s=170667a&w=0&k=20&c=j-oMdWCMLx5rIx-_W33o3q3aW9CiAWEvv9XrJQ3fTMU=",
      coverImage:
        "https://images.unsplash.com/photo-1558376939-7d6cb3025d5c?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1632&q=80",
    },
    {
      id: "16",
      artistName: "Prajwal Belavi",
      isFollowing: false,
      artistType: [{ id: "1", type: "guitarist" }],
      artistProfile:
        "https://images.unsplash.com/photo-1529665253569-6d01c0eaf7b6?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxzZWFyY2h8NHx8cHJvZmlsZXxlbnwwfHwwfHw%3D&auto=format&fit=crop&w=500&q=60",
      coverImage:
        "https://images.unsplash.com/photo-1528459801416-a9e53bbf4e17?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=712&q=80",
    },
  ],
  topBlogs: [
    {
      id: "1",
      blogHeader: "Art Culture",
      blogImage:
        "https://images.unsplash.com/photo-1512341689857-198e7e2f3ca8?auto=format&fit=crop&w=400&h=250&q=60",
      blogDetails: "25 most mesmerizing facts about Painting’s",
    },
    {
      id: "2",
      blogHeader: "Art Culture",
      blogImage:
        "https://images.unsplash.com/photo-1538032746644-0212e812a9e7?auto=format&fit=crop&w=400&h=250&q=60",
      blogDetails:
        "25 most mesmerizing facts about Painting’s 25 most mesmerizing facts about Painting’s 25 most mesmerizing facts about Painting’s 25 most mesmerizing facts about Painting’s",
    },
    {
      id: "3",
      blogHeader: "Decor",
      blogImage:
        "https://images.unsplash.com/photo-1512341689857-198e7e2f3ca8?auto=format&fit=crop&w=400&h=250&q=60",
      blogDetails: "25 most mesmerizing facts about Painting’s",
    },
    {
      id: "4",
      blogHeader: "Art Culture",
      blogImage:
        "https://images.unsplash.com/photo-1538032746644-0212e812a9e7?auto=format&fit=crop&w=400&h=250&q=60",
      blogDetails: "25 most mesmerizing facts about Painting’s",
    },
    {
      id: "5",
      blogHeader: "Decor",
      blogImage:
        "https://images.unsplash.com/photo-1529665253569-6d01c0eaf7b6?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxzZWFyY2h8NHx8cHJvZmlsZXxlbnwwfHwwfHw%3D&auto=format&fit=crop&w=500&q=60",
      blogDetails: "25 most mesmerizing facts about Painting’s",
    },
  ],
  topPosts: [
    {
      profileName: "Stacey Kibbler",
      id: 1,
      isLiked: false,
      isSaved: false,
      isFollowing: false,
      profileImage: "https://picsum.photos/2600",
      attachments: [
        {
          url: "https://picsum.photos/2300",
          height: 183,
          width: 183,
          type: "image",
        },
        {
          url: "https://picsum.photos/1900",
          likes: 734,
          isLiked: true,
          height: 183,
          width: 183,
          type: "image",
        },
      ],
      caption:
        "lets! meet at the talk show cityscape 2.0 lets! meet at the talk show cityscape 2.0…",
      projectName: "Animal Photography by me",
      admirations: "32 Admirations",
      comments: "View all 10 Comments",
    },
  ],
  artistSuggestions: [
    {
      id: 0,
      userDetails: {
        profilePic:
          "https://plus.unsplash.com/premium_photo-1667667720425-6972aff75f6b?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MXx8cHJvZmlsZXxlbnwwfHwwfHx8MA%3D%3D&auto=format&fit=crop&w=800&q=60",
        skills: ["Guitarist", "Pianist", "Music"],
        fullName: "Sheetal C Ugare",
        isSuggested: false,
      },
    },
    {
      id: 1,
      userDetails: {
        profilePic:
          "https://images.unsplash.com/photo-1511367461989-f85a21fda167?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=3431&q=80",
        skills: ["Guitarist", "Music"],
        fullName: "Punya B K",
        isSuggested: true,
      },
    },
    {
      id: 2,
      userDetails: {
        profilePic:
          "https://images.unsplash.com/photo-1521904764098-e4e0a87e3ce0?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2505&q=80",
        skills: ["Pianist", "Music"],
        fullName: "Shreedgar C Ugare",
        isSuggested: false,
      },
    },
    {
      id: 0,
      userDetails: {
        profilePic:
          "https://images.unsplash.com/photo-1500389723459-ca24a5564899?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2531&q=80",
        skills: ["Guitarist", "Pianist", "Music"],
        fullName: "Sheetal C Ugare",
        isSuggested: false,
      },
    },
    {
      id: 1,
      userDetails: {
        profilePic:
          "https://images.unsplash.com/photo-1525629179084-f7a7c04f50f1?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1yZWxhdGVkfDF8fHxlbnwwfHx8fHw%3D&auto=format&fit=crop&w=800&q=60",
        skills: ["Guitarist", "Music"],
        fullName: "Punya B K",
        isSuggested: true,
      },
    },
    {
      id: 2,
      userDetails: {
        profilePic:
          "https://images.unsplash.com/photo-1577957685568-62b29408f9e8?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1yZWxhdGVkfDV8fHxlbnwwfHx8fHw%3D&auto=format&fit=crop&w=800&q=60",
        skills: ["Pianist", "Music"],
        fullName: "Shreedgar C Ugare",
        isSuggested: false,
      },
    },
    {
      id: 0,
      userDetails: {
        profilePic:
          "https://images.unsplash.com/photo-1513257667190-565230ff0364?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1yZWxhdGVkfDZ8fHxlbnwwfHx8fHw%3D&auto=format&fit=crop&w=800&q=60",
        skills: ["Guitarist", "Pianist", "Music"],
        fullName: "Sheetal C Ugare",
        isSuggested: false,
      },
    },
    {
      id: 1,
      userDetails: {
        profilePic:
          "https://images.unsplash.com/photo-1542981042-fbe970bec260?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1yZWxhdGVkfDE1fHx8ZW58MHx8fHx8&auto=format&fit=crop&w=800&q=60",
        skills: ["Guitarist", "Music"],
        fullName: "Punya B K",
        isSuggested: true,
      },
    },
    {
      id: 2,
      userDetails: {
        profilePic:
          "https://plus.unsplash.com/premium_photo-1669061499972-21ca51155a10?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1yZWxhdGVkfDE2fHx8ZW58MHx8fHx8&auto=format&fit=crop&w=800&q=60",
        skills: ["Pianist"],
        fullName: "Shreedgar C Ugare hreedgar C Ugare",
        isSuggested: false,
      },
    },
  ],
};
